import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getProject as apiGetProject } from '~/api/civilsearch';
import type { Project } from '~/common/types';

export interface UseGetProjectOptions {
  projectId?: string;
}

export function useGetProject<T = Project>(
  { projectId }: UseGetProjectOptions,
  options?: Partial<UseQueryOptions<T, Error, T, (string | UseGetProjectOptions)[]>>,
) {
  return useQuery({
    enabled: !!projectId,
    staleTime: 0,
    gcTime: 0,
    queryKey: ['project', { projectId }],
    queryFn: () => apiGetProject<T>(projectId!),
    ...options,
  });
}
